import logoImage from "../../assest/images/logo-img.png"
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png"
import backgroundImg from "../../assest/images/signupbg2.png"
import { Link } from "react-router-dom"
import LastBox from "../../components/LastBox"
import ProviderList from "../../components/ProviderList"
import helper from "../../common/Helper"

const ResetPassword = ({
    state,
    changePassword,
    changeValue,
    showPassword, 
    showCPassword,
    handhandleShowPassword,
    getClassNames,
    isLoading,
}) => {

    const {  error, password, cpassword } = state;

    return (
        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Set a new password</h1>
                    <form onSubmit={changePassword}>
                        <div className="sq-input-wrap">
                            <label className="sq-label" htmlFor="sq-password">New Password</label>
                            <div style={{ position: "relative" }}>
                                <span className="sq-input-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0110 0v4" />
                                    </svg>
                                </span>
                                <input id="sq-password" name="password" className="sq-input" type={!showPassword ? 'password' : 'text'} value={password} placeholder="Enter New Password" onChange={changeValue} style={{ paddingRight: "2.75rem" }} required />
                                <button className="sq-pw-toggle" type="button" aria-label="Toggle password">
                                    {
                                        showPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 1)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 1)}></i>
                                    }
                                </button>
                                {error && error.password && <span className="cus-err login-err">{error.password}</span>}
                            </div>
                        </div>
                        <div className="lineSpan">
                            <span className={getClassNames(0)}></span>
                            <span className={getClassNames(1)}></span>
                            <span className={getClassNames(2)}></span>
                        </div>
                        <div className="sq-input-wrap">
                            <label className="sq-label" htmlFor="sq-password">Confirm New Password</label>
                            <div style={{ position: "relative" }}>
                                <span className="sq-input-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0110 0v4" />
                                    </svg>
                                </span>
                                <input id="sq-password" name="cpassword" className="sq-input" type={!showCPassword ? 'password' : 'text'} value={cpassword} placeholder="Confirm New Password" onChange={changeValue} style={{ paddingRight: "2.75rem" }} required />
                                <button className="sq-pw-toggle" type="button" aria-label="Toggle password">
                                    {
                                        showCPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 0)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 0)}></i>
                                    }
                                </button>
                                {error && error.cpassword && <span className="cus-err login-err">{error.cpassword}</span>}
                            </div>
                        </div>

                        <button className="common-btn sq-btn-primary" type="submit" disabled={isLoading}>
                            {isLoading ? "Loading..." : "Update Password"}
                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}
                        </button>
                    </form>
                    <div className="sq-divider">OR</div>

                    <p className="sq-signup-link">Back to <Link to={"/login"}>Login</Link></p>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ResetPassword;